import { render, staticRenderFns } from "./ReferralLinksTab.vue?vue&type=template&id=bbe05fca&scoped=true"
import script from "./ReferralLinksTab.vue?vue&type=script&lang=js"
export * from "./ReferralLinksTab.vue?vue&type=script&lang=js"
import style0 from "./ReferralLinksTab.vue?vue&type=style&index=0&id=bbe05fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe05fca",
  null
  
)

export default component.exports